import { Survey } from 'surveys/types'

export interface SurveyVersionContext {
  latestVersion: number
  minimumRequiredVersion: number
  newVersion: number
  showMinimumRequiredChoice: boolean
}

export const getSurveyVersionContext = (
  survey: Pick<Survey, 'versions' | 'minimumRequiredVersion'> | undefined,
  showMinimumRequiredChoice: boolean,
): SurveyVersionContext | undefined => {
  if (!survey?.versions?.length) {
    return undefined
  }

  const latestVersion = Math.max(...survey.versions.map(({ version }) => version))
  const minimumRequiredVersion = survey.minimumRequiredVersion ?? latestVersion

  return {
    latestVersion,
    minimumRequiredVersion,
    newVersion: latestVersion + 1,
    showMinimumRequiredChoice,
  }
}

export default getSurveyVersionContext
